import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import DraftListingContext from './DraftListing.context';
import api from 'api';
import { Listing } from 'models/Listing';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import AuthContext from 'providers/Auth/Auth.context';

const DraftListing: React.FC = (props) => {
  const { children } = props;

  const [draftListing, setDraftListing] = useState<Listing>(null);

  const { isLoggedIn } = useContext(AuthContext);
  const { popServerError } = useContext(PopNotificationsContext);

  const hasDraftBanner = useMemo(() => !!draftListing, [draftListing]);

  const removeDraftListing = useCallback(() => setDraftListing(null), []);

  useEffect(() => {
    if (!isLoggedIn) return;

    (async () => {
      try {
        const { data } = await api.portfolio.seller.getDraftListing();
        setDraftListing(data);
      } catch {
        return;
      }
    })();
  }, [isLoggedIn, popServerError]);

  return (
    <DraftListingContext.Provider
      value={{ draftListing, hasDraftBanner, removeDraftListing }}
    >
      {children}
    </DraftListingContext.Provider>
  );
};

export default DraftListing;
